import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Log In"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-log-in',
    templateUrl: './icon-log-in.component.html',
    styleUrls: ['./icon-log-in.component.scss'],
    standalone: false
})
export class IconLogInComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
